export default __webpack_public_path__ + "static/media/50.47b74021.png";